/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocationTimeZones} from '../api'

 export const useQueryGetLocationTimeZones = createReactQueryHook('getLocationTimeZones', getLocationTimeZones)
